<script>
import MubinApiServices from "../../../services/MubinApi";

export default {
  data() {
    return {
      loading: true,
      errorInCode: false,

      //sacrificer code.
      code: this.$route.params.code,
      beneficiary: null,
    };
  },
  computed: {
    getBeneficiaryRelation() {
      let relation = [
        "والد/ة",
        "زوج/ة",
        "إبن/بنت",
        "أخ/أخت",
        "جد/ة",
        "عم/ة",
        "خال/ة",
        "الزوجة الثانية",
        "الزوجة الثالثة",
        "الزوجة الرابعة",
      ];
      let beneficiaryMail_MartyrMail_Relation = [
        "مضحي بإبن",
        "مضحي بزوجة",
        "مضحي بأب",
        "مضحي بأخ",
        "مضحي بحفيد",
        "مضحي بإبن أخ",
        "مضحي بإبن أخت",
        "مضحي بزوجة",
        "مضحي بزوجة",
        "مضحي بزوجة",
      ];
      let beneficiaryFemail_MartyrMail_Relation = [
        "مضحية بإبن",
        "مضحية بزوج",
        "مضحية بأب",
        "مضحية بأخ",
        "مضحية بحفيد",
        "مضحية بإبن أخ",
        "مضحية بإبن أخت",
        "مضحية بزوج",
        "مضحية بزوج",
        "مضحية بزوج",
      ];
      let beneficiaryMail_MartyrFemail_Relation = [
        "مضحي ببنت",
        "مضحي بزوجة",
        "مضحي بأم",
        "مضحي بأخت",
        "مضحي بحفيدة",
        "مضحي ببنت أخ",
        "مضحي ببنت أخت",
        "مضحي بزوجة",
        "مضحي بزوجة",
        "مضحي بزوجة",
      ];
      let beneficiaryFemail_MartyrFemail_Relation = [
        "مضحية ببنت",
        "مضحية بزوج",
        "مضحية بأم",
        "مضحية بأخت",
        "مضحية بحفيدة",
        "مضحية ببنت أخ",
        "مضحية ببنت أخت",
        "مضحية بزوج",
        "مضحية بزوج",
        "مضحية بزوج",
      ];

      let relationIndex = relation.findIndex((r) => r == this.beneficiary.kinship);

      if (relationIndex >= 0) {
        //المستفيد ذكر
        if (this.beneficiary.gender == "ذكر") {
          if (this.beneficiary.sacrificer.gender == "ذكر") {
            return beneficiaryMail_MartyrMail_Relation[relationIndex];
          } else if (this.beneficiary.sacrificer.gender == "أنثى") {
            return beneficiaryMail_MartyrFemail_Relation[relationIndex];
          }
        }

        //المستفيد إنثى
        if (this.beneficiary.gender == "أنثى") {
          if (this.beneficiary.sacrificer.gender == "ذكر") {
            return beneficiaryFemail_MartyrMail_Relation[relationIndex];
          } else if (this.beneficiary.sacrificer.gender == "أنثى") {
            return beneficiaryFemail_MartyrFemail_Relation[relationIndex];
          }
        }
      }
      return "";
    },
  },
  methods: {
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    get() {
      MubinApiServices.checkcode(this.code)
        .then((response) => {
          this.loading = false;

          if (response.data.category != "مستفيد") {
            throw new Error("code : 500");
          }

          if (response.status == 200) {
            this.beneficiary = response.data;
          } else {
            throw new Error("Not Found code");
          }
        })
        .catch(() => {
          this.errorInCode = true;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.get();
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <div class="row con-card-imtenan mb-4" v-if="!errorInCode && !loading">
      <div class="col-md-12 mb-1">
        <h3 class="text-center pb-2">هوية امتنان</h3>
        <div class="card-imtenan-front" ref="printcontent">
          <img
            src="@/assets/images/card/card-emtenan-1.jpg"
            class="front-image"
            alt="card-emtenan"
          />
          <div class="title">
            <p class="p1">هيأة الحشد الشعبي</p>
            <p class="p2">هوية امتنان</p>
          </div>
          <div class="text">
            <p class="full-name">{{ beneficiary.fullNamePerson }}</p>
            <p class="no">
              رقم التسلسل : <span>{{ beneficiary.personCode }}</span>
            </p>
            <p class="relative-relation">
              صـلة القـرابـة : <span>{{ getBeneficiaryRelation }}</span>
            </p>
            <p class="birth-date">
              تاريخ الميلاد : <span>{{ beneficiary.BOD }}</span>
            </p>
          </div>
        </div>
        <div class="text-center mt-3">
          <a
            href="https://emtenan.org"
            class="btn btn-outline-blue"
            style="
              border-radius: 2px;
              width: 8.6cm;
              box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
            "
            >انتقل لمنصة امتنان</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
